const informe = {
  title: 'Informes',
  add: 'Agregar Informe',
  list: {
    title: 'Informe',
    columns: {
      customer: 'Cliente',
      number: 'Número',
      createdAt: 'Fecha creación',
    },
  },
  create: {
    customer: 'Cliente *',
    noContacts: 'Cliente no tiene contactos',
    contact: 'Contacto *',
    analisis: 'Analisis *',
    agreement: 'Tipo Acuerdo',
    save: 'Crear',
    list: 'Volver a la lista',
    success: 'Ingreso creado exitosamente',
    noAnalisis: 'Cliente no tiene analisis',
    docInforme: 'Redacción Informe',
    fechaExp: 'Fecha Expiración *',
    docInformeCliente: 'Informe Cliente *',
  },
  edit: {
    customer: 'Cliente *',
    contact: 'Contacto *',
    presupuesto: 'Presupuesto *',
    analisis: 'Análisis *',
    agreement: 'Tipo Acuerdo',
    save: 'Guardar',
    list: 'Volver a la lista',
    success: 'Ingreso creado exitosamente',
    docInforme: 'Redacción Informe',
    docInformeCliente: 'Informe Cliente *',
  },
};

export default informe;
